module.exports = __webpack_public_path__ + "static/media/customize_en.0aed8ff3.png";